<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "esign",
    data() {
        return {
            msg: 'E-sign Here',
        }
    },
}
</script>

<style scoped>

</style>
